module.exports = __webpack_public_path__ + "img/vddungen.68a859b3.svg";